import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import Modal from '@Components/Shared/Modals/Modal';
import EmptyLegAlertInputForm from '@Components/EmptyLegs/EmptyLegAlertInputForm';
import atoms from '@Components/Utilities/SandhillsAtoms';

const EmptyLegAlertModal = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const charterHubEmptyLegAlerts = routes?.CharterHubEmptyLegAlerts;
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleClose = () => {
        setShowConfirmation(false);
        if (props.onClose) {
            props.onClose();
        }
    };

    const handleSaveAlert = (alertData) => {
        if (props.onSave) {
            props.onSave(alertData);
        }

        if (!props.isAccountView) {
            setShowConfirmation(true);
        }
        else {
            handleClose();
        }
    };

    return (
        <Modal
            isOpen={props.isOpen || false}
            onClose={handleClose}
            className='ts-modal-container empty-leg-alert-modal'
            size='lg'
        >
            {!showConfirmation &&
                <>
                    <Modal.Header onClose={handleClose}>
                        <Modal.Title>
                            Empty Leg Alerts
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <EmptyLegAlertInputForm
                            {...(props.alert || {})}
                            onSave={handleSaveAlert}
                            onClose={handleClose}
                        />
                    </Modal.Body>
                </>}
            {showConfirmation &&
                <Modal.Body>
                    <div className='modal-content empty-leg-alert-saved-modal'>
                        <div className='modal-head'>
                            <h2>Empty Leg Alert Saved</h2>
                            <span className='close' role='button' tabIndex={0} onClick={handleClose} onKeyDown={(e) => e.key === 'Enter' && handleClose()}>
                                <i className='fas fa-times'></i>
                            </span>
                        </div>
                        <div className='modal-main'>
                            <p style={{ marginBottom: '15px' }}>Your alerts have been successfully saved and are now active. You&apos;ll start receiving updates based on your preferences.</p>
                            <p>Want to make changes? <a href={charterHubEmptyLegAlerts} style={{ fontWeight: '700' }}  target='_self'>Click Here</a> to manage, edit, or remove your alerts anytime.</p>
                        </div>
                        <div className='modal-buttons'>
                            <a className='ts-button save-modal' href={charterHubEmptyLegAlerts} target='_self'>Manage My Alerts</a>
                            <a className='ts-button close-modal' role='button' tabIndex={0} onClick={handleClose} onKeyDown={(e) => e.key === 'Enter' && handleClose()}>Close</a>
                        </div>
                    </div>
                </Modal.Body>}
        </Modal>
    );
};

export default EmptyLegAlertModal;
